import { motion } from "framer-motion";

export const FadeIn = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: "easeOut", delay }}
      viewport={{ once: true, margin: "-80px" }}
      className={className}
      {...rest}
    >
      {children}
    </M>
  );
};
